import React from "react";
import {
  GreenBadgeBase,
  BadgeImage,
  BadgeIcon,
  BadgeCopy,
  BadgeCopyHeadline,
  BadgeCopySubheadline,
} from "./green-badge.styled";
import image from "../../images/xometry-go-green.svg";
import { roundLbsOffset } from "../../utils/roundLbsOffset";
import * as FA from "../../styles/fontawesome";

interface IGreenBadgeProps {
  lbsOffset: number;
}

const GreenBadge = (props: IGreenBadgeProps) => {
  var headline = "";
  const lbsOffset = props.lbsOffset;
  if (lbsOffset) {
    const rounded = roundLbsOffset(lbsOffset);
    const roundedLbsOffset = rounded.roundedLbsOffset.toFixed(1);
    const suffix = rounded.suffix + "+";
    headline += roundedLbsOffset + suffix;
  }
  return (
    <GreenBadgeBase>
      <BadgeImage src={image} alt="Xometry Go Green Initiative" />
      <BadgeIcon css={FA.LeafRegular} />
      <BadgeCopy>
        <BadgeCopyHeadline>{headline}</BadgeCopyHeadline>
        <BadgeCopySubheadline>LBS OF CO2 OFFSET</BadgeCopySubheadline>
      </BadgeCopy>
    </GreenBadgeBase>
  );
};

export default GreenBadge;
